export default {
    canClickModalHide:true,         //控制是否点击遮罩层关闭
    closeButtonVisible:false,        //控制关闭按钮是否可见，若设置为false则canClickModalHide必定为true
    modalOpacity:0.5,               //控制遮罩层的透明度（0-1之间的number类型）
    rotateButtonVisible:false,       //控制旋转按钮是否可见
    //   kongzhi
}


// WEBPACK FOOTER //
// ./src/imageViewer/config.js